<div class="modal inmodal fade in create-modal show">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal(form)">
                        <span>×</span>
                        <span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title">
                        {{directoryService.sendInvitationMessageData.isInvitation ? 'Invitation' : 'Message'}}
                    </h4>
                </div>
                <div class="modal-body">
                    <div class="row m-b-sm increased-text">
                        <div class="col-sm-2 bold">From:</div>
                        <div class="col-sm-10">
                            {{directoryService.sendInvitationMessageData.senderName}}
                            ({{directoryService.sendInvitationMessageData.sender}})
                        </div>
                    </div>
                    <div class="row m-b-sm increased-text">
                        <div class="col-sm-2 bold">Subject:</div>
                        <div class="col-sm-10">
                            <input class="form-control"
                                   name="subject"
                                   style="height: 26px;"
                                   [(ngModel)]="directoryService.sendInvitationMessageData.subject" required>
                        </div>
                    </div>
                    <div class="row m-b-sm increased-text">
                        <div class="col-sm-2 bold">Full Name:</div>
                        <div class="col-sm-10">{{directoryService.sendInvitationMessageData.recipients[0].name}}</div>
                    </div>
                    <div class="row m-b-sm increased-text">
                        <div class="col-sm-2 bold">Email:</div>
                        <div *ngIf="!alternativeEmails.length"
                            class="col-sm-10">
                                {{directoryService.sendInvitationMessageData.recipients[0].email}}
                        </div>
                        <div *ngIf="alternativeEmails.length"
                            class="col-sm-10">
                            <select class="form-control"
                                    name="country"
                                    id="country"
                                    [(ngModel)]="emailTo">

                                <option [selected]="emailTo == directoryService.sendInvitationMessageData.recipients[0].email"
                                        [value]="directoryService.sendInvitationMessageData.recipients[0].email">
                                        {{ directoryService.sendInvitationMessageData.recipients[0].email }}
                                </option>

                                <option *ngFor="let alternativeEmail of alternativeEmails"
                                    [value]="alternativeEmail.email">
                                    {{alternativeEmail.email}}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="form-group" id="summernote">{{message}}</div>
                    <div class="row m-b-sm">
                        <div class="col-xs-8">
                            <h3>Attachments</h3>
                        </div>
                        <div class="col-xs-4">
                            <input type="file" id="add-attachment-btn" (change)="addFile($event)" [disabled]="disabledFileInput">
                            <label for="add-attachment-btn" class="btn mtv-primary-color">Add Attachment</label>
                        </div>
                    </div>
                    <ul class="attachment-box m-b-lg">
                        <li *ngFor="let item of attachments; let i = index;">
                            <a (click)="es.showAttachment(item)">
                                <div>
                                    <span class="file-name">{{item.name}}</span>
                                    <span class="file-size">({{+(item.fileSize/1000).toFixed(0)}}kb)</span>
                                </div>
                            </a>
                            <i class="fa fa-trash" (click)="removeFile(i)" title="Delete Attachment"></i>
                        </li>
                    </ul>
                    <div class="img-checkbox bold" *ngIf="corpNumber !== null && directoryService.sendInvitationMessageData.isInvitation">
                        <input type="checkbox" [(ngModel)]="saveAsDefault" id="saveAsDefault" name="saveAsDefault">
                        <label for="saveAsDefault">
                            <svg-checked></svg-checked>
                        </label>
                        Send and Save as Default Invitation Message
                    </div>
                    <div class="display-flex directory-add-modal-date-field"
                         *ngIf="!directoryService.sendInvitationMessageData.isInvitation">
                        <div class="img-checkbox bold">
                            <input type="checkbox" [(ngModel)]="sendLater" id="sendLater" name="sendLater">
                            <label for="sendLater">
                                <svg-checked></svg-checked>
                            </label>
                            Send Later
                        </div>
                        <div [hidden]="!sendLater" class="m-l-md datepicker-wrapper display-flex">
                            <label class="m-r-sm">Date</label>
                            <mat-form-field class="m-r-md inlineDateAndTime">
                                <input matInput
                                       [(ngModel)]="startDate"
                                       (focus)="startDatePicker.open()"
                                       (click)="startDatePicker.open()"
                                       name="startDate"
                                       [min]="currentTime"
                                       [matDatepicker]="startDatePicker"
                                       placeholder="Choose a date" required>
                                <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                                <mat-datepicker #startDatePicker></mat-datepicker>
                            </mat-form-field>

                            <label class="m-r-sm">Time</label>
                            <div class="input-group bootstrap-timepicker timepicker" (click)="openTimepicker()">
                                <input id="timepicker" class="form-control input-small" name="time" [ngModel]="time" required>
                                <span class="input-group-addon"><i class="glyphicon glyphicon-time"></i></span>
                            </div>
                        </div>
                    </div>
                    <div class="row text-center m-t-md">
                        <button class="btn btn-primary submit-btn" [disabled]="disabledSubmit">Send</button>
                    </div>
                    <spinner [spinnerShow]="showSpinner"></spinner>
                </div>
            </div>
        </div>
    </form>
    <spinner [spinnerShow]="es.isUploadImageSpinnerShow"></spinner>
    <div class="modal-backdrop fade in" (click)="hideModal(form)"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/directory/send-invitation-modal/send-invitation-modal.component.html